<template>
  <div class="homePage">
    <zdy-nav title="帮助与反馈" @back="back"></zdy-nav>
    <div class="scroll-list-wrap chat-window">
      <cube-scroll
        :data="chatList"
        ref="cubeScroll"
      >
        <!-- 自助工具 -->
        <self-help-tools :list="list" ></self-help-tools>
        <!-- 猜您想找 -->
        <issue-bar
          :list="issueList"
          @allIssue="allIssue"
          @toDetails="toDetails"
          @changeData="changeData"
        ></issue-bar>
        <!-- 聊天内容 -->
        <chat-content
          v-for="(item, index) in chatList"
          :key="index"
          :chatItme="item"
          @toDetails="serviceDetails"
        ></chat-content>
      </cube-scroll>
    </div>
    <input-field @sendMsg="sendMsg" ref="input-field" @inputFocus="inputFocus"></input-field>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          img: 'img/fankui.png',
          title: '异常反馈',
          click: () => {
            this.$router.push({
              name: 'feedbackPage'
            })
          }
        },
        {
          img: 'img/jianyi.png',
          title: '功能建议',
          click: () => {
            this.$router.push({
              name: 'fucSuggestPage'
            })
          },
        },
        {
          img: 'img/update.png',
          title: '检查更新',
          click: () => {
            this.$cjc.apiCheckAppUpdate();
          },
        },
      ],
      issueList: [], // 问题列表
      chatList: [], // 聊天列表
      pageIndex: 1,
      pageSize: 6,
      total: 0,
    };
  },
  created() {
    document.title = '帮助与反馈'
    this.getQuestionList();
    console.log(this.$cjc)
  },
  methods: {
    back() {
      this.$cjc.closeWebView();
    },
    // 获取猜你想找列表
    getQuestionList() {
      this.$store.dispatch('questionList', {
        current: this.pageIndex,
        size: this.pageSize,
      }).then((res) => {
        const { result } = res.data;
        if (res.data.status === 1000) {
          this.issueList = result.records;
          this.total = result.total;
        } else {
          const toast = this.$createToast({
            txt: res.data.msg,
            time: 2000,
            type: 'error',
          });
          toast.show();
        }
      })
    },
    sendMsg(msg) {
      if (!msg) return;
      const cubeScroll = this.$refs.cubeScroll.scroll; 
      const { userInfo } = this.$store.state;
      const sendObj = {
        type: 1, // 用户发言
        msg,
      };
      this.chatList = this.chatList.concat(sendObj);
      this.$store.dispatch('robotSearchLucene', {
        keyId: userInfo.USER_ID,
        useType: '手机',
        useDevice: userInfo.phoneType == 2 ? '安卓' : 'iOS',
        deviceType: userInfo.model,
        question: msg,
      }).then((res) => {
        if (res.data.status === 1000) {
          const { result } = res.data;
          let resultObj = {};
          if (result.resultList.length > 0) {
            resultObj = {
              type: 2, // 问答服务
              resultList: result.resultList,
            }
          } else {
            resultObj = {
              type: 3, // 无法理解提问
              noResultMsg: result.noResultMsg,
            }
          }
          this.chatList = this.chatList.concat(resultObj);
          if (cubeScroll.scrollerHeight > cubeScroll.wrapperHeight) {
            // console.log('scrollerHeight', cubeScroll.scrollerHeight);
            // console.log('wrapperHeight', cubeScroll.wrapperHeight);
            this.$refs.cubeScroll.scrollTo(
              0,
              -cubeScroll.scrollerHeight,
              500,
            )
          }
        } else {
          const toast = this.$createToast({
            txt: res.data.msg,
            time: 2000,
            type: 'error',
          })
          toast.show()
        }
      })
    },
    inputFocus() {
    //   const cubeScroll = this.$refs.cubeScroll.scroll; 
    //   setTimeout(() => {
    //     if (cubeScroll.scrollerHeight > cubeScroll.wrapperHeight) {
    //       console.log('scrollerHeight', cubeScroll.scrollerHeight);
    //         console.log('wrapperHeight', cubeScroll.wrapperHeight);
    //       this.$refs.cubeScroll.scrollTo(
    //         0,
    //         -cubeScroll.scrollerHeight,
    //         500,
    //       )
    //     }
    //   }, 0)
    },
    // 全部问题
    allIssue() {
      this.$router.push({ name: 'allIssue' });
    },
    toDetails(item) {
      if (item.answerType === 1) {
        this.$router.push({ name: 'answerPage', params: item });
      } else {
        // window.open(item.answer);
        this.openWindow(item.answer, item.questionName, false)
      }
    },
    serviceDetails(item) {
      //type类型 1为服务 2为问题
      // value_type 值类型:1文本 2链接 主要在type = 2时使用
      if (item.type === 1) {
        this.enterService(item);
      } else {
        if (item.value_type === 1) {
          this.$router.push({ name: 'answerPage', params: item });
        } else {
          this.openWindow(item.value, item.name, false)
        }
      }
      console.log(item)
    },
    // 进入服务
    enterService(item) {
      const { userInfo } = this.$store.state;
      this.$store.dispatch('enterService', {
        serviceId: item.id,
        userId: userInfo.USER_ID,
        useDevice: userInfo.phoneType == 2 ? '安卓' : 'iOS',
        deviceType: userInfo.model,
        ip: '',
      }).then((res) => {
        if (res.data.status === 1000) {
          this.openWindow(item.value, item.name, true)
        } else {
          const toast = this.$createToast({
            txt: res.data.msg,
            time: 2000,
            type: 'error',
          })
          toast.show()
        }
      })
    },
    // 换一换
    changeData() {
      const pages = Math.ceil(this.total / 6);
      if (this.pageIndex < pages) {
        this.pageIndex += 1;
      } else {
        this.pageIndex = 1;
      }
      this.getQuestionList();
    },
    openWindow(serviceUrl, title, hiddenNavigation){
      if (this.environment.isFengChao) {
        this.$cjc.openNewWebView({
          'url': serviceUrl,
          'title': title == undefined ? '详情页' : title,
          'hiddenNavigation': hiddenNavigation
        })
      } else {
        window.open(item.value);
      }
    }
  }
}
</script>

<style lang="scss">
.homePage {
  height: calc(100vh - 50px);
  .chat-window {
    background-color: #F6F6F6;
    margin-top: 50px;
    height: calc(100vh - 100px);
    overflow-y: auto;
    .cube-scroll-wrapper {
      padding: 0 10px;
    }
  }
}
</style>